/*
 * Botón "Comprar ahora": manda la variante seleccionada directo al checkout
 * usando un cart permalink (/cart/{variant_id}:{quantity}).
 * Independiente del botón de pago dinámico de Shopify.
 */
(function () {
  if (window.buyNowInitialized) return;
  window.buyNowInitialized = true;

  function findForm(button) {
    return document.getElementById(button.getAttribute('data-form-id'));
  }

  // Refleja el estado (agotado / disponible) del botón "Agregar al carrito",
  // que es el que el JS del tema actualiza al cambiar de variante.
  function syncButtonState(button) {
    var form = findForm(button);
    if (!form) return;
    var addToCart = form.querySelector('[data-add-to-cart]');
    if (addToCart) button.disabled = addToCart.disabled;
  }

  function syncAllButtons() {
    var buttons = document.querySelectorAll('[data-buy-now]');
    for (var i = 0; i < buttons.length; i++) syncButtonState(buttons[i]);
  }

  document.addEventListener('change', function () {
    window.setTimeout(syncAllButtons, 50);
  });

  // Al volver con "atrás" desde el checkout, la página puede salir del bfcache con el botón deshabilitado.
  window.addEventListener('pageshow', syncAllButtons);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-buy-now]');
    if (!button) return;
    event.preventDefault();

    var form = findForm(button);
    if (!form) return;

    var addToCart = form.querySelector('[data-add-to-cart]');
    if (addToCart && addToCart.disabled) return;

    // form.elements incluye inputs asociados por atributo form= (como el de cantidad).
    var variantField = form.elements.namedItem('id');
    var quantityField = form.elements.namedItem('quantity');
    var variantId = variantField ? variantField.value : '';
    var quantity = quantityField ? parseInt(quantityField.value, 10) : 1;

    if (!variantId) return;
    if (!quantity || quantity < 1) quantity = 1;

    button.disabled = true;
    window.location.href = button.getAttribute('data-cart-url') + '/' + encodeURIComponent(variantId) + ':' + quantity;
  });
})();
